import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Défilement vers le haut lors du changement de page
  }, [location]); // Cette fonction sera exécutée chaque fois que la localisation (URL) change

  return null; // Ce composant ne rend rien de visible, il fait juste défiler la page
};

export default ScrollToTop;
